import { render, staticRenderFns } from "./dashboard-table.vue?vue&type=template&id=34a1d03a"
import script from "./dashboard-table.vue?vue&type=script&lang=js"
export * from "./dashboard-table.vue?vue&type=script&lang=js"
import style0 from "./dashboard-table.vue?vue&type=style&index=0&id=34a1d03a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports